(function (window) {
  /**
   * BatchGeoMarkerTooltip is a wrapper around BatchGeoMapTooltip that handles
   * showing and hiding tooltips when you hover in/out of markers.
   *
   * @example
   * var marker = new google.maps.Marker({...});
   * new BatchGeoMarkerTooltip(marker);
   *
   * @param {object} marker
   * @constructor
   */
  var BatchGeoMarkerTooltip = function (marker) {
    this.tooltip = null;
    this.intentTimer = null;
    this.marker = marker;
    this.data = window.per.mapRS[marker.id];
    google.maps.event.addListener(marker, "mouseover", this.init.bind(this));
  };

  /**
   * This is called on mouseover automatically but can also be triggered
   * manually if needed.
   */
  BatchGeoMarkerTooltip.prototype.init = function () {
    var self = this;
    var clickedMarker =
      BatchGeoStore.getState().MapsMarkersManager.clickedMarker;

    // If the marker that was clicked on is the marker that's getting a
    // mouseover event then exit this and wait for it not to be the current
    // marker. Also checks if there is any clickedMarker because if the user
    // has not clicked any marker at all this will be null
    if (
      window.BatchGeoStore.getState().MapsMarkersManager.openStatus &&
      clickedMarker &&
      clickedMarker.id === this.marker.id
    ) {
      return;
    }

    // If no address can be shown and there's no title there's nothing to
    // show in the tooltip so just exit
    if ((window.per.hideaddr_cb || !this.data.addr) && !this.data.t) {
      return;
    }

    this.tooltip = new BatchGeoMapTooltip({
      map: window.batchGeoGoogleMapsManager.getMap(),
      position: this.marker.position,
      title: this.data.t,
      text: !window.per.hideaddr_cb ? this.data.addr : "",
    });

    // To make sure the user actually wanted to hover over a marker and was
    // not just moving their cursor across the map we set a timer. If the
    // user waits on the marker for 350ms itll trigger the tooltip init. If
    // not it'll stop the timer so it's never fired.
    this.intentTimer = setTimeout(function () {
      self.tooltip.init();
    }, 350);

    google.maps.event.addListener(
      this.marker,
      "mouseout",
      this.destroy.bind(this),
    );
    google.maps.event.addListener(
      this.marker,
      "click",
      this.destroy.bind(this),
    );
  };

  /**
   * Clears the intent timer and destroys the BatchGeoMapTooltip instance
   */
  BatchGeoMarkerTooltip.prototype.destroy = function () {
    clearTimeout(this.intentTimer);
    this.tooltip.destroy();
  };

  window.BatchGeoMarkerTooltip = BatchGeoMarkerTooltip;
})(window);
